import { Swiper } from 'swiper';
import { Navigation, Controller } from 'swiper/modules';

export class ComparisonProducts {
	private element: HTMLElement;
	private readonly sliderElement: HTMLElement;
	private readonly buttonPrev: HTMLButtonElement;
	private readonly buttonNext: HTMLButtonElement;
	private readonly fixedClass: string = 'comparison-products--fixed';
	private readonly shownClass: string = 'comparison-products--show';
	private readonly hideClass: string = 'comparison-products--hide';
	private readonly productFixedClass: string = 'product-block--comparison';
	private readonly parent: ParentNode;
	private readonly nextEl: Element;
	private readonly productElements: NodeList;
	private fixPoint: number;
	private showTopPoint: number;
	private showBottomPoint: number;
	private marginTop: number; 
	private isFixed: boolean = false;
	private isShown: boolean = false;
	private slider: Swiper;
	private control: Swiper;
	private getSliderOptions = () => ({
		slidesPerView: 'auto',
		modules: [Navigation, Controller],
		navigation: {
			prevEl: this.buttonPrev,
			nextEl: this.buttonNext,
		},
		controller: {
			control: this.control,
		},
		loop: true,
	});

	private handleScroll = (): void => {
		if (window.scrollY >= this.fixPoint && !this.isFixed) this.fix();
		else if (window.scrollY < this.fixPoint && this.isFixed) this.unfix();
		else if ((window.scrollY >= this.showTopPoint && window.scrollY < this.showBottomPoint) && !this.isShown) this.show();
		else if ((window.scrollY < this.showTopPoint || window.scrollY > this.showBottomPoint) && this.isShown) this.hide();
	};

	private fix = (): void => {
		const parentGap = getComputedStyle(this.parent).getPropertyValue('row-gap');
		this.marginTop = this.element.offsetHeight + parseInt(parentGap, 10);
		this.element.classList.add(this.fixedClass);
		this.parent.style.setProperty('padding-top', `${this.marginTop}px`);
		this.productElements.forEach((element) => element.classList.add(this.productFixedClass));
		this.isFixed = true;
		this.showBottomPoint = 
			(this.parent.getBoundingClientRect().bottom + window.scrollY) 
			- this.element.offsetHeight
			- document.querySelector('.header-main').offsetHeight;
	};

	private unfix = (): void => {
		this.marginTop = null;
		[this.fixedClass, this.hideClass].forEach((className) => this.element.classList.remove(className));
		this.parent.style.removeProperty('padding-top');
		this.productElements.forEach((element) => element.classList.remove(this.productFixedClass));
		this.isFixed = false;
	};

	private show = () => {
		this.element.classList.remove(this.hideClass);
		this.element.classList.add(this.shownClass);
		this.isShown = true;
	};

	private hide = () => {
		this.element.classList.remove(this.shownClass);
		this.element.classList.add(this.hideClass);
		this.isShown = false;
	};

	constructor(element, control) {
		if (!element) return;
		this.element = element;
		this.control = control;
		this.parent = this.element.parentNode;
		this.nextEl = this.element.nextElementSibling;
		this.productElements = this.element.querySelectorAll('.product-block');
		this.sliderElement = this.element.querySelector('.comparison-products__swiper');
		this.buttonPrev = this.element.querySelector('.comparison-products__button--prev');
		this.buttonNext = this.element.querySelector('.comparison-products__button--next');

		this.init();
	}

	public init = (): void => {
		this.slider = new Swiper(this.sliderElement, this.getSliderOptions());
		this.fixPoint = this.element.getBoundingClientRect().bottom + window.scrollY;
		this.showTopPoint = this.fixPoint + this.nextEl.offsetHeight;
		this.handleScroll();
		window.addEventListener('scroll', this.handleScroll);
	};

	public destroy = () => {
		this.slider.destroy();
		this.slider = null;
		this.fixPoint = null;
		this.showTopPoint = null;
		window.removeEventListener('scroll', this.handleScroll);
	};
}
